import ReactDOM from 'react-dom/client';
import {
	App,
	SessionProvider,
	UserProvider,
	ConfigProvider,
	APIContainer,
} from '@mono-farmart-web/farmart-ai';
import { NavigationProvider } from '@mono-farmart-web/navigation-context/context/Navigation';
import { BrowserRouter as Router } from 'react-router-dom';
import { initI18n } from '@mono-farmart-web/i18n';
import { logger } from '@mono-farmart-web/logger';
import { name as appName, version as appVersion } from '../package.json';

const noopFalse = (_l: string) => false;

logger.initialize({
	serviceName: appName,
	version: appVersion,
	environment: import.meta.env.VITE_ENV,
});

initI18n();

const root = ReactDOM.createRoot(document.getElementById('root')!);
root.render(
	<NavigationProvider>
		<SessionProvider>
			<UserProvider>
				<ConfigProvider
					customHeaders={{}}
					appTitle='FarMart AI'
					isStandalone
					baseRoute=''
					getIsInternalRoute={noopFalse}
					userMeta={{}}
				>
					<APIContainer>
						<Router>
							<App />
						</Router>
					</APIContainer>
				</ConfigProvider>
			</UserProvider>
		</SessionProvider>
	</NavigationProvider>,
);
